export const CM_TIMELINE_VIEW_FLAG_NAME = 'pen-5613_v1'
